var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRequerantHelpIcon = function SvgRequerantHelpIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 117,
    viewBox: "0 0 600 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 58.7617,
    rx: 42,
    ry: 42,
    fill: "#F9FAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 38.7617C288.96 38.7617 280 47.7217 280 58.7617C280 69.8017 288.96 78.7617 300 78.7617C311.04 78.7617 320 69.8017 320 58.7617C320 47.7217 311.04 38.7617 300 38.7617ZM302 72.7617H298V68.7617H302V72.7617ZM306.14 57.2617L304.34 59.1017C303.34 60.1217 302.62 61.0417 302.26 62.4817C302.1 63.1217 302 63.8417 302 64.7617H298V63.7617C298 62.8417 298.16 61.9617 298.44 61.1417C298.84 59.9817 299.5 58.9417 300.34 58.1017L302.82 55.5817C303.74 54.7017 304.18 53.3817 303.92 51.9817C303.66 50.5417 302.54 49.3217 301.14 48.9217C298.92 48.3017 296.86 49.5617 296.2 51.4617C295.96 52.2017 295.34 52.7617 294.56 52.7617H293.96C292.8 52.7617 292 51.6417 292.32 50.5217C293.18 47.5817 295.68 45.3417 298.78 44.8617C301.82 44.3817 304.72 45.9617 306.52 48.4617C308.88 51.7217 308.18 55.2217 306.14 57.2617Z",
    fill: "#BDC5D6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRequerantHelpIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "requerant-help-icon.06e9e949dcb177ea06a0753dc0c40022.svg";